import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import React, { useState, useEffect } from "react";
import { Controller, useFieldArray, useForm, useWatch } from "react-hook-form";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

import apiHelper from "../../../../util/ApiHelper";
import { useLoading } from "../../../../util/LoadingProvider";

const useStyles = makeStyles({
  root: {
    marginBottom: "40px",
    "& .ck-editor__editable_inline": {
      minHeight: "200px",
    },
  },
  button: {
    backgroundColor: "#306F9D",
    textTransform: "capitalize",
    color: "white",
    "&:hover": {
      backgroundColor: "#306F9D",
    },
  },
});


function EditMenuPage({ disabled, ...props }) {
  const classes = useStyles();
  const { setLoading } = useLoading();
  const [data, setData] = React.useState({});
  const [defaultValues, setDefaultValues] = React.useState({
    status: {
      status: true,
      deleted: false
    },
    isHeader: 0,
    isExternal: 0,
    localizations: {
      en: { externalUrl: "https://www.example.com/en/" },
      tc: { externalUrl: "https://www.example.com/tc/" },
    },
  });

  const id = props.match.params.id;

  const getMenu = React.useCallback(async () => {
    setLoading(true);
    const result = await apiHelper.hkiffApp.getHkiffAppMenuById(id);
    setData(result.data);
    setDefaultValues(result.data);
    setLoading(false);
  }, [id, setData, setDefaultValues]);

  const onSubmit = async (values) => {
    console.log(values);
    setLoading(true);

    const requestBody = [{
      id: id,
      status: values.status,
      isExternal: values.isExternal,
      isHeader: values.isHeader,
      localizations: values.localizations,
    }];
    
    try {
      const result = await apiHelper.hkiffApp.updateHkiffAppMenuById(requestBody);
      console.log(result.data);
      toast.dark("Your changes is saved.");
      getMenu();
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  useEffect(() => {
    getMenu();
  }, []);

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  return (
    // data && (
    <Grid
      container
      xs={12} md={8}
      component="form"
      onSubmit={handleSubmit(onSubmit)}
      direction="column"
    >
      <fieldset disabled={disabled} className="fieldset" style={{ width: "80%" }}>
        <Typography variant="h4" gutterBottom>
          Menu > Edit Menu
        </Typography>
        <Box display="flex" flexDirection="column" className={classes.root}>
          <Controller
            name="localizations.en.title"
            control={control}
            defaultValue={defaultValues.localizations?.en?.title}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="Menu Title (English)"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={
                  error
                    ? error.message
                    : "The name is how it appears on your site."
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
            rules={{ required: "Menu Title (English) required" }}
          />
          <Controller
            name="localizations.tc.title"
            control={control}
            defaultValue={defaultValues.localizations?.tc?.title}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="Menu Title (Traditional Chinese)"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={
                  error
                    ? error.message
                    : "The name is how it appears on your site."
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
            rules={{
              required: "Menu Title (Traditional Chinese) required",
            }}
          />
          <Controller
            name="localizations.en.externalUrl"
            control={control}
            defaultValue={defaultValues.localizations?.en?.externalUrl}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="External URL (English)"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={
                  error
                    ? error.message
                    : " "
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
          <Controller
            name="localizations.tc.externalUrl"
            control={control}
            defaultValue={defaultValues.localizations?.tc?.externalUrl}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                margin="dense"
                label="External URL (Traditional Chinese)"
                variant="outlined"
                value={value}
                onChange={onChange}
                error={!!error}
                helperText={
                  error
                    ? error.message
                    : ""
                }
                InputLabelProps={{ shrink: true }}
              />
            )}
          />
          <Box pl={1} mt={2}>
          <Controller
              name="isExternal"
              control={control}
              render={({
                field: { value, onChange, ...rest },
                fieldState: { error },
              }) => {
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        type="checkbox"
                        color="primary"
                        checked={value}
                        onChange={(event) => {
                          console.log(event.target.checked);
                          setValue(
                            "isExternal",
                            event.target.checked ? 1 : 0
                          );
                        }}
                        {...rest}
                      />
                    }
                    label="Is External URL"
                  />
                );
              }}
            />
          </Box>
         
        </Box>
        <Grid xs={12}>
          {disabled || (
            <Button
              className={classes.button}
              type="submit"
              variant="contained"
              color="primary"
            >
              Save Changes
            </Button>
          )}
        </Grid>
      </fieldset>
    </Grid>
    // )
  );
}

export default EditMenuPage;
